module.exports = __webpack_public_path__ + "img/Ariho-Nicholas.3747846d.jpeg";